// Regroupe une liste de formations par catégorie ("Sans catégorie" en dernier)
export function groupFormationsByCategory(formations) {
  const map = new Map();
  (Array.isArray(formations) ? formations : []).forEach((f) => {
    const cat = f.FormationCategory;
    const key = cat ? `c${cat.id}` : "none";
    if (!map.has(key)) {
      map.set(key, { key, name: cat ? cat.name : "Sans catégorie", uncategorized: !cat, items: [] });
    }
    map.get(key).items.push(f);
  });
  return Array.from(map.values()).sort((a, b) => {
    if (a.uncategorized) return 1;
    if (b.uncategorized) return -1;
    return a.name.localeCompare(b.name, "fr");
  });
}
